import { render, staticRenderFns } from "./AuthPopup.vue?vue&type=template&id=46a81ffc&"
import script from "./AuthPopup.vue?vue&type=script&lang=js&"
export * from "./AuthPopup.vue?vue&type=script&lang=js&"
import style0 from "./AuthPopup.vue?vue&type=style&index=0&id=46a81ffc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports